//@flow
import * as Immutable from 'immutable';

import TerritoryPlanningActions from 'common/redux/actions/territoryPlanning';

export const territoryPlanning = (
    state = Immutable.fromJS({
        territory: {}
    }),
    action
) => {
    switch (action.type) {
        case TerritoryPlanningActions.FETCH_ALL_DISTRIBUTOR_OUTLETS_START: {
            const path = ['territory', 'distributor'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'isLoading'], true);
            });
        }

        case TerritoryPlanningActions.FETCH_ALL_DISTRIBUTOR_OUTLETS_SUCCESS: {
            const path = ['territory', 'distributor'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'isLoading'], false);
            });
        }
        case TerritoryPlanningActions.FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_START: {
            const path = ['territory', 'nonDistributor'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'isLoading'], true);
            });
        }

        case TerritoryPlanningActions.FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_SUCCESS: {
            const path = ['territory', 'nonDistributor'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'isLoading'], false);
            });
        }
        case TerritoryPlanningActions.CREATE_ZONE_MAP_START: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    [...path, 'creatingNewZoneMapInProgress'],
                    true
                );
            });
        }
        case TerritoryPlanningActions.CREATE_ZONE_MAP_SUCCESS: {
            const { zone } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    [...path, 'creatingNewZoneMapInProgress'],
                    false
                );
                mutableState.setIn([...path, 'latestZoneMap'], zone);
            });
        }
        case TerritoryPlanningActions.CREATE_ZONE_MAP_FAILURE: {
            const { error } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    [...path, 'creatingNewZoneMapInProgress'],
                    false
                );
                mutableState.setIn([...path, 'latestZoneMap', 'error'], error);
            });
        }
        case TerritoryPlanningActions.FETCH_TEAM_HOMEBASE_START: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'homeBases', 'isLoading'], true);
            });
        }
        case TerritoryPlanningActions.FETCH_TEAM_HOMEBASE_SUCCESS: {
            const { homebases } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'homeBases', 'isLoading'], false);
                mutableState.setIn(
                    [...path, 'homebases', 'homebasesList'],
                    homebases
                );
            });
        }
        case TerritoryPlanningActions.FETCH_TEAM_HOMEBASE_FAILURE: {
            const { error } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'homeBases', 'isLoading'], false);
                mutableState.setIn([...path, 'homeBases', 'error'], error);
            });
        }
        case TerritoryPlanningActions.SORT_OUTLET_START: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'sortOutlet', 'isLoading'], true);
            });
        }
        case TerritoryPlanningActions.SORT_OUTLET_SUCCESS: {
            const { outlet } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'sortOutlet', 'isLoading'], false);
                mutableState.setIn([...path, 'sortOutlet', 'outlet'], outlet);
            });
        }
        case TerritoryPlanningActions.SORT_OUTLET_FAILURE: {
            const { error } = action;
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'sortOutlet', 'isLoading'], false);
                mutableState.setIn([...path, 'sortOutlet', 'error'], error);
            });
        }
        case TerritoryPlanningActions.UPDATE_OUTLET_START: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'updateOutletInProgress'], true);
            });
        }
        case TerritoryPlanningActions.UPDATE_OUTLET_SUCCESS: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'updateOutletInProgress'], false);
            });
        }
        case TerritoryPlanningActions.UPDATE_OUTLET_FAILURE: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'updateOutletInProgress'], false);
            });
        }
        case TerritoryPlanningActions.UNASSIGN_OUTLET_START: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn([...path, 'unassignOutletInProgress'], true);
            });
        }
        case TerritoryPlanningActions.UNASSIGN_OUTLET_SUCCESS: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    [...path, 'unassignOutletInProgress'],
                    false
                );
            });
        }
        case TerritoryPlanningActions.UNASSIGN_OUTLET_FAILURE: {
            const path = ['territory'];
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    [...path, 'unassignOutletInProgress'],
                    false
                );
            });
        }
    }
    return state;
};
